export class MegaMenuTabs {
  constructor() {
    this.classNames = {
      component: 'b-af-mega-tab-columns',
      tab: 'b-af-mega-tab-columns__tab',
      tabActive: 'b-af-mega-tab-columns__tab--active',
      trigger: 'b-af-mega-tab-columns__nav-item',
      triggerActive: 'b-af-mega-tab-columns__nav-item--active',
    };

    this.initialize();
  }

  initialize() {
    const components = Array.from(document.querySelectorAll(`.${this.classNames.component}`))

    if (components.length === 0) return;

    this.initComponents(components);
  }

  initComponents(components) {
    components.forEach((component) => {
      const tabs = Array.from(component.querySelectorAll(`.${this.classNames.tab}`));
      const triggers = Array.from(component.querySelectorAll(`.${this.classNames.trigger}`))

      this.initTabs(tabs, triggers);
      this.setFirstTriggerAsActive(triggers);
    });
  }

  setFirstTriggerAsActive(triggers) {
    if (triggers && triggers.length > 0) {
      triggers[0].classList.add(this.classNames.triggerActive);
    }
  }

  initTabs(tabs, triggers) {
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (window.innerWidth >= 992) {
          event.preventDefault();

          const tabTargetIndex = trigger.dataset.buttonIndex;

          this.toggleTabs(tabTargetIndex, tabs);
          this.handleTriggersClass(triggers, tabTargetIndex);

          return;
        }

        if (event.target.matches([`.b-af-mega-tab-columns__nav-link-tab-link`, '.b-af-mega-tab-columns__nav-link-tab-link *'])) {
          const href = event.target.dataset.url || event.target.parentNode.dataset.url;

          if (href) {
            window.location.href
          }
        }
      });
    });
  }

  toggleTabs(tabTargetIndex, tabs) {
    tabs.forEach((tab) => {
      const tabSourceIndex = tab.dataset.index;

      tab.classList.toggle(
        this.classNames.tabActive,
        tabSourceIndex === tabTargetIndex
      );
    });
  }

  handleTriggersClass(triggers, triggerTargetIndex) {
    triggers.forEach((trigger) => {
      const triggerSourceIndex = trigger.dataset.buttonIndex;

      trigger.classList.toggle(
        this.classNames.triggerActive,
        triggerSourceIndex === triggerTargetIndex
      );
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/megaMenuTabs.js